import { useEffect, useState } from "react";
import { IoCloseOutline } from "react-icons/io5";

interface ObjectFormProps {
  onSave: (name: string, description?: string) => void;
  onCancel: () => void;
  isSaving?: boolean;
  show: boolean;
  name?: string;
  description?: string;
  title?: string;
  showDescription?: boolean;
}

export const ObjectForm = (props: ObjectFormProps) => {
  const [name, setName] = useState(props.name ?? "");
  const [description, setDescription] = useState(props.description ?? "");
  const [error, setError] = useState("");

  useEffect(() => {
    setName(props.name ?? "");
    setDescription(props.description ?? "");
  }, [props.name, props.description]);

  if (!props.show) return null;

  const handleSave = () => {
    if (!name.trim()) {
      setError("Name is required");
      return;
    }
    setError("");

    if (props.showDescription) {
      props.onSave(name, description);
      setName("");
      setDescription("");
    } else {
      props.onSave(name);
      setName("");
    }
  };

  const handleCancel = () => {
    setName(""); // Clear the form
    setDescription(""); // Clear description
    setError(""); // Clear error message
    props.onCancel();
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 "
      style={{ zIndex: 2 }}
    >
      <div className="relative max-w-3xl w-full bg-white p-6 rounded-lg shadow-md">
        <button
          onClick={handleCancel}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 transition"
        >
          <IoCloseOutline size={30} />
        </button>
        <h2 className="text-xl font-semibold text-gray-700 mb-4">
          {props.title || "Saving"}
        </h2>
        <div className="mb-4">
          <label className="block text-gray-700 font-medium mb-2">Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter file name"
          />
          {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
        </div>
        {props.showDescription && (
          <div className="mb-4">
            <label className="block text-gray-700 font-medium mb-2">
              Description
            </label>
            <input
              type="text"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter file name"
            />
          </div>
        )}
        <div className="flex space-x-4 justify-end">
          <button
            onClick={handleCancel}
            className="bg-gray-300 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-400 transition"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="px-4 py-2 border rounded-lg bg-[#2fe9ff] text-white hover:bg-[#2fe9ff]-600 flex items-center justify-center"
          >
            {props.isSaving ? (
              <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-white mr-3"></div>
            ) : null}
            {props.isSaving ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};
